import { memo } from "react";
import { formatMessageTime } from "../../../function/CustomFunction";
import MessageContent from "./messageContent";

function Incoming({ chat }) {
  return (
    <div className="px-2 px-md-3 px-lg-4 my-1 d-flex chat chat-start">
      {/* position: relative so the absolute timestamp anchors correctly */}
      <div
        className="position-relative shadow-sm px-3 py-2 chat-bubble"
        style={{
          maxWidth: "75%",
          minWidth: "130px",
          backgroundColor: "#FFFFFF",
          color: "#111B21",
          borderRadius: "12px",
          borderTopLeftRadius: "2px",
          userSelect: "text",
          transition: "background-color 0.2s ease",
        }}
      >
        <div className="mb-1">
          <MessageContent chat={chat} sending_type="incoming" />
        </div>
        <div className="d-flex justify-content-end" style={{ zIndex: 10 }}>
          <small
            className="text-muted"
            style={{ fontSize: "0.7rem" }}
          >
            {formatMessageTime(chat.date, chat.time)}
          </small>
        </div>
      </div>
    </div>
  );
}

export default memo(Incoming);
